<template>
  <div class="nt-Tabs_NavItem">
    <button
      @click="setActive(mutateUrl, scrollTo)"
      :class="{
        'nt-Tabs_NavPill': type === 'pill',
        'nt-Tabs_NavLink': type === 'item',
        'nt-Tabs_NavLink-active': isActive,
      }"
      type="button"
    >
      <slot></slot>
      <CircleAttention v-if="hasError" class="text-danger svg-12" />
    </button>
  </div>
</template>

<script>
import CircleAttention from "../../icons/atalanda/circle-attention.svg";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TabNavItem",
  components: {
    CircleAttention,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "item",
    },
    initialActive: {
      type: Boolean,
      required: false,
    },
    mutateUrl: {
      type: Boolean,
      required: false,
      default: false,
    },
    scrollTo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({ tabs: "getGlobalTabs", errorTabs: "getErrorTabs" }),
    isActive() {
      return this.tabs[this.$parent.id] === this.id;
    },
    hasError() {
      return this.errorTabs.includes(this.id);
    },
  },
  mounted() {
    const activeTab = this.checkForHash();

    if (activeTab === this.id) {
      this.setActive(false, false);
    } else if (!activeTab && this.initialActive) {
      this.setActive(false, false);
    }
  },
  methods: {
    ...mapActions({ setGlobalTabs: "setGlobalTabs" }),
    setActive(mutateUrl = this.mutateUrl, scrollTo = this.scrollTo) {
      this.setGlobalTabs({
        mutateUrl,
        scrollTo,
        data: { [this.$parent.id]: this.id },
      });
    },
    checkForHash() {
      let hash = window.location.hash.substring(1);
      const params = hash.split("&").reduce((acc, val) => {
        const [tabNav, activeTab] = val.split("=");
        return { ...acc, [tabNav]: activeTab };
      }, {});

      return params[this.$parent.id];
    },
  },
};
</script>
